<template>
    <div class="contract-manage-iflow-table">
        <table-box v-loading="subTabTable.tableLoading" :selection="TABLECONFIG.selection"
            :columns="TABLECONFIG.columns" :height="tableHeight" :actions="TABLECONFIG.actions"
            :rows="subTabTable.totalData" @action-click="actionClick">
            <template v-slot:col-append="{ col, row }">
                <div v-if="col.prop === 'mipUrl'">
                    <span size="mini" type="text" class="mip-page-link no-wrap" :title="row.mipUrl"
                        @click="handleLink(row)">{{ row.mipUrl || '' }}</span>
                </div>
            </template>
        </table-box>
        <div class="footer">
            <lots-pagination @size-change='subTabTable.sizeChange' :current-page.sync='subTabTable.pageNo'
                @current-change='subTabTable.pageChange' size="small" layout='total, sizes, prev, pager, next, jumper'
                :total='subTabTable.pageTotal' />
        </div>
    </div>
</template>

<script>
import lotsPagination from '@/components/lots/lotsPagination/Index';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { getIflowDetailList } from '@mdm/api/contractManage/contractRegistration.js';
import { ref, watch, computed, reactive } from '@vue/composition-api';
import { tableConfig } from './config.js';
import tableBox from '@/components/lots/tableBox/Index';
export default {
    components: {
        lotsPagination, tableBox
    },
    emits: ['getNewIflowList'],
    props: {
        activeName: {
            type: String,
            default: () => ''
        },
        detailPageState: {
            type: String,
            default() {
                return '';
            }
        },
        detailData: {
            type: Object,
            return: () => {}
        },
        tableHeight: {
            type: Number,
            default: 357
        },
        actions: { // 表格操作信息，不传默认为空
            type: Object,
            default() {
                return {
                    list: []
                };
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(tableConfig);
        // eslint-disable-next-line complexity
        const TABLECONFIG = computed(() => {
            return config;
        });
        class IflowTalbeClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition.renewalIds = [props.detailData.id];
                return condition;
            }
            afterGetList(res) {
                if (+res.code === 0 && res.data && res.data.list) {
                    setupContext.emit('getNewIflowList', res.data.list);
                }
                super.afterGetList(res);
            }
        };
        const subTabTable = new IflowTalbeClass({
            Api: {
                listApi: getIflowDetailList
            }
        });
        const handleLink = (row) => {
            window.open(row.mipUrl, '_blank');
        };
        const dictData = ref({});
        watch(
            () => [props.activeName, props.detailData.contractCode, props.detailData.contractChangeCode],
            (newVal, oldVal) => {
                if (newVal[0] === 'iflowDetail') {
                    subTabTable.getList();
                } else if (!newVal[1]) {
                    subTabTable.totalData.value = [];
                    subTabTable.pageTotal.value = 0;
                }
            }
        );
        // onActivated(() => {
        //     getDataFn();
        // });
        // const getDataFn = () => {
        //     props.activeName === 'iflowDetail'
        //         && subTabTable.getList();
        // };
        const actionClick = (event, row) => {
            if (event === 'abandom') {
                subTabTable.deleteRow({ mipId: row.mipId }, {
                    msg: '请确认是否特权废弃该流程？该操作不可恢复',
                    successMsg: '特权废弃成功！'
                });
            }
        };
        return {
            config,
            TABLECONFIG,
            dictData,
            subTabTable,
            handleLink,
            actionClick
        };
    }
};
</script>
<style lang='less'>
.contract-manage-iflow-table {
    // margin-top: 15px;
    .footer {
        padding: 10px 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .mip-page-link {
        color: #4285f5;
        cursor: pointer;
        &.no-wrap {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
</style>
